import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { throwError as observableThrowError, Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { PosDevice } from "../../models/entity/posDevice";
import { SelectedItemIdDto } from "../../models/dto/selectedItemIdDto";
import { RequestCacheService } from "../core/request-cache.service";
import { StoreView } from "../../models/dto/storeView";
import { StoreModel } from "../../models/entity/store/store.model";
import { StoreSettingEntity } from "../../models/entity/store/store-setting.entity";
import { SmsSettingEntity } from "../../models/entity/sms/sms-setting-entity";
import { ReceiptSetting } from "../../models/entity/receiptSetting";
import { BaseRestService } from "../base-rest.service";
import { SmsTemplateEntity } from "../../models/entity/sms/sms-template-entity";
import { StoreRelationUpdateRequest } from "../../models/rest/store/store-relation-update-request.model";
import { ServiceCar } from "../../models/entity/serviceCar";
import { StoreTemplate } from "../../models/entity/store/store-template";
import { BillingEntity } from "../../models/entity/billing/billing.model";
import { OnlineMerchantModel } from "../../models/entity/online-collection/online-merchant.model";
import { StoreHangerTypeView } from "../../models/dto/store/store-hanger-type-view.model";
import { MailSettingModel } from "../../models/entity/store/mail-setting.model";
import { StockTrackingEntity } from "../../models/entity/order/stock-tracking.entity";
import { BillingSettingModel } from "../../models/entity/billing/billing-setting.model";
import { NotificationPreferenceEntity } from "../../models/entity/notification/notification-preference-entity";
import { PushNotificationTemplateEntity } from "../../models/entity/notification/push-notification-template.entity";
import { StorageCostSettingEntity } from "../../models/entity/storage/storage-cost-setting.entity";
import { SegmentValueEntity } from "../../models/entity/segment/segment-value.entity";
import { CashRegisterEntity } from "../../models/entity/cash-register/cash-register-entity";
import { PayrollSettingEntity } from "../../models/entity/payroll/payroll-setting.entity";
import { CommonRequest } from "../../models/rest/common/commonRequest";
import { Device } from "../../models/entity/device";
import { SessionStorageService } from "../session-storage.service";
import { OrderItemType } from "../../models/entity/product/orderItemType";
import { AllStoreRelationsResponse } from "../../models/rest/store/all-store-relations-response.model";

@Injectable({
  providedIn: "root"
})
export class StoreService extends BaseRestService {
  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService,
    private cache: RequestCacheService) {
    super(httpClient, sessionStorageService);
  }



  getStores(): Observable<StoreView[]> {
    const url = `/stores`;
    return this.httpGet<StoreView[]>(url).pipe(catchError(this.errorHandler));
  }

  getStoreById(id) {
    const url = `/stores/${id}`;
    return this.httpGet(url).pipe(catchError(this.errorHandler));
  }

  addStore(address) {
    const url = `/stores`;
    return this.httpPost(url, address).pipe(catchError(this.errorHandler));
  }

  updateStore(id, address): Observable<StoreModel> {
    const url = `/stores/${id}`;
    return this.httpPut<StoreView>(url, address)
      .pipe(catchError(this.errorHandler));
  }

  deleteStore(id) {
    const url = `/stores/${id}`;
    return this.httpDelete(url).pipe(catchError(this.errorHandler));
  }
  getStoresBySearch(request: CommonRequest): Observable<StoreView[]> {
    const url = `/stores/search`;
    return this.httpPost<StoreView[]>(url, request).pipe(catchError(this.errorHandler));
  }
  //İzin verilen şubeler
  getStoreSelectList(storeId, type: string): Observable<SelectedItemIdDto[]> {
    const url = `/stores/${storeId}/allowed?type=${type}`;
    return this.httpGet<SelectedItemIdDto[]>(url)
      .pipe(catchError(this.errorHandler));
  }
  getAllowedStoreSelectList(storeId: number, type: string): Observable<SelectedItemIdDto[]> {
    const url = `/stores/${storeId}/store-relation?type=${type}`;
    return this.httpGet<SelectedItemIdDto[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  getAllStoreRelations(storeId: number): Observable<AllStoreRelationsResponse> {
    const url = `/stores/${storeId}/all-store-relations`;
    return this.httpGet<AllStoreRelationsResponse>(url)
      .pipe(catchError(this.errorHandler));
  }

  //Ana işlem tipleri
  getStoreMainProcessTypes(storeId): Observable<SelectedItemIdDto[]> {
    const url = `/stores/${storeId}/main-process-types`;
    return this.httpGet<SelectedItemIdDto[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  getStoreMainProcessTypesForWeb(storeId): Observable<OrderItemType[]> {
    const url = `/stores/${storeId}/main-process-types-web`;
    return this.httpGet<OrderItemType[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  //Pos Cihazları
  getPosDevices(storeId): Observable<PosDevice[]> {
    //
    const url = `/stores/${storeId}/pos-devices`;
    return this.httpGet<PosDevice[]>(url).pipe(catchError(this.errorHandler));
  }

  //Servis Aaçları
  getServiceCars(storeId): Observable<ServiceCar[]> {
    //
    const url = `/stores/${storeId}/service-cars`;
    return this.httpGet<PosDevice[]>(url).pipe(catchError(this.errorHandler));
  }
  //Servis Aaçları
  getDevices(storeId): Observable<Device[]> {
    //
    const url = `/stores/${storeId}/devices`;
    return this.httpGet<Device[]>(url).pipe(catchError(this.errorHandler));
  }

  //Ayarlar
  getSetting(storeId: number): Observable<StoreSettingEntity> {
    //
    const url = `/stores/${storeId}/setting`;
    return this.httpGet<StoreSettingEntity>(url).pipe(catchError(this.errorHandler));
  }
  getPayrollSetting(storeId: number): Observable<PayrollSettingEntity> {
    //
    const url = `/stores/${storeId}/payroll-setting`;
    return this.httpGet<PayrollSettingEntity>(url).pipe(catchError(this.errorHandler));
  }


  //Sms
  getSmsSetting(storeId: number, channelType: string): Observable<SmsSettingEntity> {
    //
    const url = `/stores/${storeId}/sms-setting?channel-type=${channelType}`;
    return this.httpGet<SmsSettingEntity>(url).pipe(catchError(this.errorHandler));
  }
  getMailSetting(storeId: number): Observable<MailSettingModel> {
    //
    const url = `/stores/${storeId}/mail-setting`;
    return this.httpGet<MailSettingModel>(url).pipe(catchError(this.errorHandler));
  }
  //Makbuz Ayarları
  getReceiptSetting(storeId: number): Observable<ReceiptSetting> {
    //
    const url = `/stores/${storeId}/receipt-setting`;
    return this.httpGet<ReceiptSetting>(url)
      .pipe(catchError(this.errorHandler));
  }
  getReceiptSettingByReceiptType(storeId: number, receiptType: string): Observable<ReceiptSetting> {
    //
    const url = `/stores/${storeId}/receipt-setting?type=${receiptType}`;
    return this.httpGet<ReceiptSetting>(url)
      .pipe(catchError(this.errorHandler));
  }
  //Makbuz Ayarları
  getLabelSetting(storeId: number): Observable<ReceiptSetting> {
    //
    const url = `/stores/${storeId}/label-setting`;
    return this.httpGet<ReceiptSetting>(url)
      .pipe(catchError(this.errorHandler));
  }



  //Sms templates
  getSmsTemplates(storeId): Observable<SmsTemplateEntity[]> {
    const url = `/stores/${storeId}/sms-templates`;
    return this.httpGet<SmsTemplateEntity[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  getPushNotificationTemplates(storeId): Observable<PushNotificationTemplateEntity[]> {
    const url = `/stores/${storeId}/push-notification-templates`;
    return this.httpGet<PushNotificationTemplateEntity[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  getNotificationPreferences(storeId): Observable<NotificationPreferenceEntity[]> {
    const url = `/stores/${storeId}/notification-preferences`;
    return this.httpGet<NotificationPreferenceEntity[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  //Sms templates
  getStoreTemplates(storeId): Observable<StoreTemplate[]> {
    const url = `/stores/${storeId}/templates`;
    return this.httpGet<StoreTemplate[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  storeRelationUpdate(request: StoreRelationUpdateRequest[]) {
    const url = `/stores/store-relation-update`;

    return this.httpPost(url, request).pipe(catchError(this.errorHandler));
  }

  //Sms templates
  getStoreLastBilling(storeId): Observable<BillingEntity> {
    const url = `/stores/${storeId}/last-billing`;
    return this.httpGet<BillingEntity>(url)
      .pipe(catchError(this.errorHandler));
  }

  //Online merchants
  getStoreOnlineMerchants(storeId): Observable<OnlineMerchantModel[]> {
    const url = `/stores/${storeId}/online-merchants`;
    return this.httpGet<OnlineMerchantModel[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  //Active Online merchants
  getStoreActiveOnlineMerchant(storeId): Observable<OnlineMerchantModel> {
    const url = `/stores/${storeId}/active-online-merchants`;
    return this.httpGet<OnlineMerchantModel>(url)
      .pipe(catchError(this.errorHandler));
  }

  //Online merchants
  getStoreHangerTypes(storeId): Observable<StoreHangerTypeView[]> {
    const url = `/stores/${storeId}/hanger-types`;
    return this.httpGet<StoreHangerTypeView[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  //Stok Takip
  getStockTrackings(storeId): Observable<StockTrackingEntity[]> {
    const url = `/stores/${storeId}/stock-trackings`;
    return this.httpGet<StockTrackingEntity[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  //Billign Setting
  getBillingSetting(storeId: number): Observable<BillingSettingModel> {
    const url = `/stores/${storeId}/billing-setting`;
    return this.httpGet<BillingSettingModel>(url).pipe(catchError(this.errorHandler));
  }

  getStorageCostSettingByStoreId(storeId: number): Observable<StorageCostSettingEntity> {
    const url = `/stores/${storeId}/storage-cost-setting`;
    return this.httpGet<BillingSettingModel>(url).pipe(catchError(this.errorHandler));
  }
  getSegmentValuesByStoreId(storeId: number, segmentId: number): Observable<SegmentValueEntity[]> {
    const url = `/stores/${storeId}/segment-values?segment-id=${segmentId}`;
    return this.httpGet<SegmentValueEntity[]>(url).pipe(catchError(this.errorHandler));
  }

  getCashRegistersByStoreId(storeId: number,): Observable<CashRegisterEntity[]> {
    const url = `/stores/${storeId}/cash-registers`;
    return this.httpGet<CashRegisterEntity[]>(url).pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    //console.log(error);
    return observableThrowError(error);
  }
}
